import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { tableCellCentered } from '../../../../../assets/js/styles'

import { CustomDataTableHeader, CustomPanel, SelectEmpresas } from '../../../../../components'

import useDiariasPorVeiculo, { LOAD_MESSAGE } from './DiariasPorVeiculoHook'
import DiariasPorVeiculoModal from './DiariasPorVeiculoModal'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

function DiariasPorVeiculo({ history, selectedTp, dispatch }) {
  const { state, localDispatch } = useDiariasPorVeiculo()

  /* carrega tiposVeiculos + tp selecionado */
  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  /* loading global */
  useEffect(() => {
    if (state.loadingMessage !== LOAD_MESSAGE.NONE)
      dispatch(showLoadingBox(null, state.loadingMessage))
    else dispatch(hideLoadingBox())
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) dispatch(showMessageBox(null, state.errorMessage))
  }, [state.errorMessage])

  const tabelaDados = state.selectedEmpresa
    ? state.diarias.map(d => {
        const tipo = state.tiposVeiculos.find(t => t.id === d.manufacturer_id)
        return {
          ...d,
          /* agora usa o mesmo label do cadastro de veículos */
          tipoVeiculo: (tipo && (tipo.name || tipo.model)) || '-',
        }
      })
    : []

  return (
    <div style={{ marginTop: 20 }}>
      <CustomPanel
        onNovo={localDispatch.onBtnNovo}
        onVoltar={history.goBack}
        novoDisabled={!state.selectedEmpresa}
      >
        {/* ---- Empresa ---- */}
        <div className="p-grid" style={{ marginBottom: 10 }}>
          <div className="p-col-12 p-md-4">
            <SelectEmpresas
              disabled={!selectedTp}
              companyId={state.selectedEmpresa ? state.selectedEmpresa.id : null}
              onChange={localDispatch.onEmpresaChange}
            />
          </div>
        </div>

        {/* ---- Tabela ---- */}
        <div className="p-grid">
          <div className="p-col-12">
            <DataTable
              value={tabelaDados}
              header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
              emptyMessage="Selecione uma empresa para visualizar."
              globalFilter={state.globalFilter}
              paginator
              rows={10}
              selectionMode="single"
              onSelectionChange={e => localDispatch.onDataTableItemClicked(e.value)}
            >
              <Column field="day" header="Dia" style={tableCellCentered(80)} />
              <Column field="tipoVeiculo" header="Tipo de Veículo" style={tableCellCentered(250)} />
              <Column
                field="value"
                header="Valor (R$)"
                body={valorBody}
                style={tableCellCentered(120)}
              />
            </DataTable>
          </div>
        </div>
      </CustomPanel>

      <DiariasPorVeiculoModal
        show={state.modal.show}
        data={state.modal.data}
        tiposVeiculos={state.tiposVeiculos}
        diarias={state.diarias}
        onSave={localDispatch.onModalSave}
        onClose={localDispatch.onModalClose}
      />
    </div>
  )
}

const valorBody = row =>
  Number(row.value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(DiariasPorVeiculo))
